import React, { useState, useEffect, lazy, Suspense } from "react";
import "./category.css";
import { Headers } from "../../layouts/headers/headers";
import { MainContent } from "../../layouts/MainContent";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { RolesList } from "../../components/datatable/RolesList";
import UserFilter from "../../components/filters/filterUser";
import { FaUserPlus } from "react-icons/fa"; // ícono liviano
import { useAuth } from "../../contexts/authContexts";
import { useNavigate } from "react-router-dom";

// ✅ Lazy modales
const AsigPermisUser = lazy(() => import("../../components/modals/asigPermisUser"));
const CreateUser = lazy(() => import("../../components/modals/createUser"));
const UserModal = lazy(() => import("../../components/modals/profileUser"));
const PermissionDeniedModal = lazy(() => import("../../components/modals/denegPermisse"));

const Category = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [activeModal, setActiveModal] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const { user } = useAuth();
  const navigate = useNavigate();
  const tienePermiso = user?.permissions?.some(p => p.name === "manage-users-roles");

  useEffect(() => {
    if (!tienePermiso) setShowPermissionModal(true);
  }, [tienePermiso]);

  const closePermissionModal = () => {
    setShowPermissionModal(false);
    navigate("/Control-Tecnico");
  };

  const handleRefresh = () => setRefresh(prev => !prev);

  const openModal = (modalType, user) => {
    setSelectedUser(user);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedUser(null);
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Headers />

      {/* Contenido principal */}
      <MainContent>
        <HeadersCentral
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
          openModal={() => openModal("user")}
        />

        <main className="p-6">
          <h1 className="text-2xl font-bold mb-7">Panel de Control de Usuarios</h1>
          <UserFilter setRoles={setRoles} />

          {/* Botón para crear usuario */}
          <div className="mb-4 flex justify-start">
            <button
              className="bg-yellow-400 hover:bg-yellow-600 text-white px-5 py-1 text-lg rounded flex items-center justify-center gap-2 shadow-md w-auto"
              onClick={() => openModal("createUser")}
            >
              <FaUserPlus size={18} /> Crear usuario
            </button>
          </div>

          {/* Lista de Roles */}
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <RolesList
              roles={roles}
              openModal={openModal}
              setRoles={setRoles}
              refresh={refresh}
              onSuccess={handleRefresh}
            />
          </div>
        </main>
      </MainContent>
      {/* Modales */}
      <Suspense fallback={null}>
        {showPermissionModal && (
          <PermissionDeniedModal
            isOpen={showPermissionModal}
            onClose={closePermissionModal}
          />
        )}
        {activeModal === "user" && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === "createUser" && (
          <CreateUser isOpen={true} onClose={closeModal} onSuccess={handleRefresh} />
        )}
        {activeModal === "permiss" && (
          <AsigPermisUser
            isOpen={true}
            onClose={closeModal}
            users={selectedUser}
            onSuccess={handleRefresh}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Category;
